import React from "react";

const Procedure = ({ className = "madie-icon", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.78722 4.74286C3.57089 4.74286 4.20617 4.02651 4.20617 3.14286C4.20617 2.2592 3.57089 1.54286 2.78722 1.54286C2.00356 1.54286 1.36827 2.2592 1.36827 3.14286C1.36827 4.02651 2.00356 4.74286 2.78722 4.74286ZM2.78722 6.28571C4.32656 6.28571 5.57445 4.87861 5.57445 3.14286C5.57445 1.40711 4.32656 0 2.78722 0C1.24788 0 0 1.40711 0 3.14286C0 4.87861 1.24788 6.28571 2.78722 6.28571Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.78722 14.4571C3.57089 14.4571 4.20617 13.7408 4.20617 12.8571C4.20617 11.9735 3.57089 11.2571 2.78722 11.2571C2.00356 11.2571 1.36827 11.9735 1.36827 12.8571C1.36827 13.7408 2.00356 14.4571 2.78722 14.4571ZM2.78722 16C4.32656 16 5.57445 14.5929 5.57445 12.8571C5.57445 11.1214 4.32656 9.71429 2.78722 9.71429C1.24788 9.71429 0 11.1214 0 12.8571C0 14.5929 1.24788 16 2.78722 16Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.5304 3.14264C13.4491 3.1574 13.3216 3.20905 13.1524 3.39926C12.8612 3.72651 10.4278 6.11539 8.05995 8.43992C6.9547 9.52494 5.86373 10.5959 5.01158 11.4367L4.11056 10.2756C5.01586 9.3824 6.16737 8.25198 7.31602 7.12437C9.62834 4.8544 11.9291 2.5958 12.1863 2.30661C12.5239 1.92715 12.9031 1.69383 13.3128 1.61942C13.7173 1.54595 14.0874 1.63895 14.395 1.78712C14.9633 2.06081 15.4227 2.57948 15.6663 2.85446C15.6734 2.86243 15.6803 2.87019 15.687 2.87774C15.9541 3.17899 15.9541 3.66739 15.687 3.96866L12.1166 7.99533L15.6869 12.0205C16.0777 12.4612 16.0303 13.0542 15.9284 13.4173C15.8178 13.8118 15.5875 14.1908 15.2886 14.4737C14.9856 14.7606 14.5707 14.9863 14.0851 14.9809C13.587 14.9754 13.1082 14.7278 12.6924 14.2589L9.14499 10.2589L10.1125 9.16796L13.6599 13.168C13.8694 13.4042 14.02 13.4372 14.0985 13.4381C14.1894 13.4391 14.298 13.397 14.4088 13.2921C14.5092 13.1971 14.5781 13.0808 14.6115 12.9899L10.6653 8.54096C10.537 8.3963 10.4649 8.20009 10.4649 7.99549C10.4649 7.7909 10.537 7.59467 10.6653 7.44999L14.2129 3.449C14.0967 3.34878 13.9781 3.26399 13.8576 3.20597C13.7218 3.14058 13.6168 3.12694 13.5304 3.14264ZM14.633 12.9134C14.6332 12.906 14.6342 12.9016 14.6342 12.9016C14.6342 12.9016 14.6345 12.905 14.633 12.9134Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.62428 8.54632L4.07691 4.54632L5.04442 3.45536L8.5918 7.45536L7.62428 8.54632Z"
      />
    </svg>
  );
};

export default Procedure;
